/* upk-lazy.js (P13c.3 and C2, 21 Oct 2026): one IntersectionObserver, 600 px ahead of the viewport, for what is kept out of the
   page until it is near: images that carry data-upk-src / data-upk-srcset / data-upk-poster (the stacks, the influencer looks,
   the doors, the evil eye band; the attribute is swapped in and the class upk-lazy dropped) and sections that carry
   data-upk-lazy-section (the Instagram app block on the home page, sections/apps.liquid: the section is fetched through the
   Section Rendering API on a collection URL, the part named by data-upk-lazy-part is copied in and the block's scripts run in
   document order, inline first and deferred files after, the way the parser would have). Nothing here fires before the
   element is within 600 px. window.upkLazy.watch(root) registers elements added later (the tab fetches). */
(function () {
  if (window.upkLazy) return;
  var MARGIN = '600px 600px 600px 600px'; /* the home rails scroll sideways, so the margin runs sideways too */
  var SEL = 'img[data-upk-src], img[data-upk-srcset], video[data-upk-poster], [data-upk-lazy-section]';
  var hasIO = 'IntersectionObserver' in window;
  var io = null;

  function hydrateMedia(el) {
    var ss = el.getAttribute('data-upk-srcset'); if (ss) { el.setAttribute('srcset', ss); el.removeAttribute('data-upk-srcset'); }
    var s = el.getAttribute('data-upk-src'); if (s) { el.setAttribute('src', s); el.removeAttribute('data-upk-src'); }
    var p = el.getAttribute('data-upk-poster'); if (p) { el.setAttribute('poster', p); el.removeAttribute('data-upk-poster'); }
    el.classList.remove('upk-lazy');
  }

  /* Scripts inserted with innerHTML or importNode never run; re-create them. Inline and plain external scripts run in document
     order (externals awaited); scripts marked defer or type=module run after them, in order, as the parser would schedule them. */
  function runScripts(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('script'));
    var now = [], later = [];
    all.forEach(function (s) { var deferred = s.hasAttribute('defer') || s.type === 'module'; (deferred ? later : now).push(s); });
    function runOne(old) {
      return new Promise(function (resolve) {
        var s = document.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
        s.removeAttribute('defer');
        if (old.src) { s.onload = s.onerror = function () { resolve(); }; s.async = false; }
        else { s.text = old.text; }
        old.parentNode.replaceChild(s, old);
        if (!old.src) resolve();
      });
    }
    return now.reduce(function (p, s) { return p.then(function () { return runOne(s); }); }, Promise.resolve())
      .then(function () { return later.reduce(function (p, s) { return p.then(function () { return runOne(s); }); }, Promise.resolve()); });
  }

  function hydrateSection(el) {
    var src = el.getAttribute('data-upk-lazy-section'); var id = el.getAttribute('data-upk-lazy-id'); var part = el.getAttribute('data-upk-lazy-part');
    if (!src || !id || el.dataset.upkLoaded) return;
    el.dataset.upkLoaded = '1';
    fetch(src, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (json) {
        var html = json[id]; if (!html) throw new Error('no section');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = (part && doc.querySelector(part)) || doc.getElementById('shopify-section-' + id) || doc.body;
        var frag = document.createDocumentFragment();
        Array.prototype.slice.call(source.childNodes).forEach(function (n) { frag.appendChild(document.importNode(n, true)); });
        el.innerHTML = ''; el.appendChild(frag);
        el.classList.add('is-loaded'); el.removeAttribute('aria-busy');
        return runScripts(el).then(function () { try { document.dispatchEvent(new CustomEvent('upk:lazy:section', { detail: { id: id, root: el } })); } catch (e) {} });
      })
      .catch(function () { delete el.dataset.upkLoaded; el.classList.add('is-failed'); });
  }

  function hydrate(el) {
    if (el.hasAttribute('data-upk-lazy-section')) hydrateSection(el); else hydrateMedia(el);
  }

  /* An image inside a rail that scrolls sideways (the stacks, the looks, the doors, the evil eye band) is clipped by the rail
     once it is past the rail's edge, and the viewport observer never sees it, however wide the margin. So when one image of a
     rail hydrates, every image within 600 px of the rail's visible edge hydrates too, and the rail's own scroll keeps that up. */
  function scrollerOf(el) {
    var p = el.parentElement;
    while (p && p !== document.body) { var cs = getComputedStyle(p); if (/(auto|scroll)/.test(cs.overflowX)) return p; p = p.parentElement; }
    return null;
  }
  function hydrateNear(scroller) {
    var r = scroller.getBoundingClientRect();
    Array.prototype.slice.call(scroller.querySelectorAll('img[data-upk-src], img[data-upk-srcset], video[data-upk-poster]')).forEach(function (el) {
      var b = el.getBoundingClientRect();
      if (b.left < r.right + 600 && b.right > r.left - 600) { if (io) io.unobserve(el); hydrate(el); }
    });
  }
  function watchRail(el) {
    var sc = scrollerOf(el); if (!sc) return;
    if (!sc.dataset.upkRail) {
      sc.dataset.upkRail = '1';
      var t = null;
      sc.addEventListener('scroll', function () { if (t) return; t = setTimeout(function () { t = null; hydrateNear(sc); }, 120); }, { passive: true });
    }
    hydrateNear(sc);
  }

  function watch(root) {
    var scope = root || document;
    var els = scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(SEL)) : [];
    if (scope !== document && scope.matches && scope.matches(SEL)) els.unshift(scope);
    if (!hasIO) { els.forEach(hydrate); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting || en.intersectionRatio > 0) { io.unobserve(en.target); hydrate(en.target); if (!en.target.hasAttribute('data-upk-lazy-section')) watchRail(en.target); } });
      }, { rootMargin: MARGIN, threshold: 0 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  window.upkLazy = { watch: watch, hydrate: hydrate };
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', function () { watch(); });
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
  /* Printing: nothing lazy should be missing from a printed page. */
  window.addEventListener('beforeprint', function () { Array.prototype.slice.call(document.querySelectorAll(SEL)).forEach(hydrate); });
})();
